import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { TaskService } from 'src/app/services/task.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';

@Component({
  selector: 'app-activated-process-list',
  templateUrl: './activated-process-list.component.html',
  styleUrls: ['./activated-process-list.component.css']
})
export class ActivatedProcessListComponent implements OnInit {

  public environmentSettings: any;
  isSearchDivVisible = false;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();

  dtOptionsforProcessTasks: DataTables.Settings = {};
  dtTriggerforProcessTasks: Subject<any> = new Subject();

  processMasterForm: FormGroup;
  processes: any[];
  meetingTypes: any[];
  processId: string;
  meetingtypeId: string;
  meetingType: string;
  isMeetingTask: boolean;
  processTaskId: string;
  processType: string;
  processtasklist: any[];
  SearchprocessUserdefinedorPredefinedModel: any;
  error: any = { isError: false, errorMessage: '' };

  minDateForSearchFrom: NgbDateStruct;
  minDateForSearchTo: NgbDateStruct;
  todayDateforSearchMeeting: NgbDateStruct;
  activatedTaskSearchDateFrom: NgbDateStruct;
  activatedTaskSearchDateTo: any;
  response:boolean;
  isLoading: boolean = false;

  constructor(private processMasterService: ProcessMasterService, private taskService: TaskService, 
    private alert: AlertComponent, private commonFunction: CommonFunction, private router: Router,private route: ActivatedRoute) { 
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;

    this.commonFunction.removeDataTableSaveStateKey("processTable");

    this.initialiseJqueryEvents();
   
    let searchflag = localStorage.getItem('searchactiveprocess');

    // var searchParameters = {
      
    //         UserdefinedorPredefined: (this.SearchprocessUserdefinedorPredefinedModel === undefined) ? null : this.SearchprocessUserdefinedorPredefinedModel,
    //         FromDate: (this.activatedTaskSearchDateFrom === undefined) ? null : this.setDate(this.activatedTaskSearchDateFrom),
    //         ToDate: (this.activatedTaskSearchDateTo === undefined) ? null : this.setDate(this.activatedTaskSearchDateTo),
    //       };
      



    if(searchflag=='true'){

      let searchnewdata = JSON.parse(localStorage.getItem('inputdata'));
      
      if (searchnewdata.UserdefinedorPredefined) {
        this.SearchprocessUserdefinedorPredefinedModel = searchnewdata.UserdefinedorPredefined;
        
      }

      if (searchnewdata.FromDate) {
        let dt = new Date(this.commonFunction.setFormatDate(searchnewdata.FromDate))
        this.activatedTaskSearchDateFrom = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }

      }
      if (searchnewdata.ToDate) {
        let dt2 = new Date(this.commonFunction.setFormatDate(searchnewdata.ToDate))
        this.activatedTaskSearchDateTo = { month: dt2.getMonth() + 1, day: dt2.getDate(), year: dt2.getFullYear() }
      }

      this.getActivatedProcessListBySearchFilter(searchnewdata);
      
    }

    else{
      this.getActivatedProcessList();
      
    }
  

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      stateSave: true,
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [4] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Activated Process List',
          title: 'Activated Process List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2,3],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }


        }
      ]
    };

  }

  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);

  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getActivatedProcessList() {
    this.isLoading = true;
    this.processes = [];
    // var processTable = $('#processTable').DataTable({ destroy: true });
    // processTable.destroy();
    if (this.dtElement && this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }
    //this.processMasterService.getActivatedProcessList()
    this.processMasterService.getActivatedProcessListwithPendingandPartiallyCompletedStatus()
      .subscribe(processList => {
        if (processList.status == 0) {
          //this.processes=processList.processList;

          // console.log("processList.processList"+processList.processList.ProcessTasksData);

          var uniqueProcessess = _.uniqBy(processList.processList.ProcessTasksData, 'ProcessName');
          //this.processes = processList.processList.ProcessTasksData;
          this.processes = uniqueProcessess;
          this.response = false;

          this.dtTrigger.next();
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      })
  }

  getProcessListByProcessType(processType) {
    this.isLoading = true;
    this.processes = [];
    if (this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }

    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }
    // this.processService.getProcessListByProcessType(processType)
    this.processMasterService.getActivatedProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          var processData = $(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          this.processes = this.commonFunction.sortByKey(processData, 'ProcessName');
          this.dtTrigger.next();
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      })
  }

  showAllProcesses() {
    this.response = true;

    localStorage.setItem('searchactiveprocess','false');

    this.getActivatedProcessList()
    this.SearchprocessUserdefinedorPredefinedModel = null;
    this.activatedTaskSearchDateFrom = null;
    this.activatedTaskSearchDateTo = null;
  }


  showProcessTasks(processId) {
    // this.router.navigate(['/process/activatedtasks', processId]);
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['process', 'activatedtasks',processId]  } }],
      { relativeTo: this.route.parent });
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.year + "-" + date.month + "-" + date.day;
    }
    return null;
  }

  showTasksBySearchData() {
    this.response = true ;

    localStorage.setItem('searchactiveprocess','true');
    var searchParameters = {

      UserdefinedorPredefined: (this.SearchprocessUserdefinedorPredefinedModel === undefined) ? null : this.SearchprocessUserdefinedorPredefinedModel,
      FromDate: (this.activatedTaskSearchDateFrom === undefined) ? null : this.setDate(this.activatedTaskSearchDateFrom),
      ToDate: (this.activatedTaskSearchDateTo === undefined) ? null : this.setDate(this.activatedTaskSearchDateTo),
    };

    localStorage.setItem('inputdata',JSON.stringify(searchParameters));

    this.getActivatedProcessListBySearchFilter(searchParameters);
  }


  getActivatedProcessListBySearchFilter(searchParameters) {
    this.isLoading = true;
    this.processes = [];
    // var processTable = $('#processTable').DataTable({ destroy: true });
    // processTable.destroy();
    if (this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }
    //this.processMasterService.getActivatedProcessList()
    this.processMasterService.getActivatedProcessListBySerachFilters(searchParameters)
      .subscribe(processList => {
        if (processList.status == 0) {
          //this.processes=processList.processList;
           console.log("processList..");
          // console.log("processList.processList"+processList.processList.ProcessTasksData);

          // console.log("processList.resultobjectData"+processList.processList.resultobjectData);

          // var uniqueProcessess = _.uniqBy(processList.processList, 'ProcessName');
          // this.processes = processList.processList;

          var uniqueProcessess = _.uniqBy(processList.processList.ProcessTasksData, 'ProcessName');
          //this.processes = processList.processList.ProcessTasksData;
          this.processes = uniqueProcessess;
          this.response = false;

          //var uniqueProcessess = _.uniqBy(processList.processList.ProcessTasksData, 'ProcessName');

          //processList.processList.ProcessTasksData
          //this.processes = uniqueProcessess;
          //this.processes = processList.processList.ProcessTasksData;

          // console.log("processList.resultobjectData" + processList.processList.resultobjectData);
          console.log("this.processes"+ this.processes);
         

          this.dtTrigger.next();
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      })
  }

  activatedTaskSearchFromDuedateChange(){
    var dateObj = new Date();
    this.todayDateforSearchMeeting={ year: dateObj.getUTCFullYear(), month: dateObj.getUTCMonth() +1, day: dateObj.getUTCDate() };
    this.minDateForSearchTo=this.activatedTaskSearchDateTo;
  
  }

  initialiseJqueryEvents() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    $('#processDialog').on('shown.bs.modal', function (e) {
      $('#processName').focus();
    });

  }
}
